var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(-5.309 -61.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M6.182,11.531A5.991,5.991,0,0,1,0,5.765,5.991,5.991,0,0,1,6.182,0a5.991,5.991,0,0,1,6.181,5.765A5.991,5.991,0,0,1,6.182,11.531Zm0-10.438a4.856,4.856,0,0,0-5.01,4.673,4.856,4.856,0,0,0,5.01,4.673,4.855,4.855,0,0,0,5.009-4.673A4.855,4.855,0,0,0,6.182,1.093Z",
    transform: "translate(5.309 61.156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M11.309,11.535a.6.6,0,0,1-.414-.16L8.273,8.93a.52.52,0,0,1,0-.773.618.618,0,0,1,.828,0L11.723,10.6a.521.521,0,0,1,0,.773A.6.6,0,0,1,11.309,11.535Zm-8.2-4.978a.568.568,0,0,1-.586-.546V5.535a2.541,2.541,0,0,1-1.2-.638L.887,5.14a.615.615,0,0,1-.3.078.6.6,0,0,1-.5-.266.512.512,0,0,1-.068-.4A.547.547,0,0,1,.284,4.2l.44-.246a2.172,2.172,0,0,1,0-1.358l-.44-.245a.549.549,0,0,1-.269-.346.513.513,0,0,1,.068-.4.6.6,0,0,1,.5-.266.617.617,0,0,1,.3.078l.435.244a2.544,2.544,0,0,1,1.2-.639V.546A.568.568,0,0,1,3.106,0a.568.568,0,0,1,.586.546v.474a2.556,2.556,0,0,1,1.175.618l.4-.223a.617.617,0,0,1,.3-.078.592.592,0,0,1,.5.266.513.513,0,0,1,.069.4.549.549,0,0,1-.269.346l-.391.218a2.16,2.16,0,0,1,0,1.413l.391.218a.547.547,0,0,1,.269.346.512.512,0,0,1-.068.4.591.591,0,0,1-.5.266.615.615,0,0,1-.3-.078l-.4-.222a2.527,2.527,0,0,1-1.175.617v.476A.568.568,0,0,1,3.106,6.557Zm0-4.508A1.277,1.277,0,0,0,1.787,3.278a1.278,1.278,0,0,0,1.318,1.23,1.278,1.278,0,0,0,1.318-1.23A1.277,1.277,0,0,0,3.106,2.049Z",
    transform: "translate(8.414 63.621)",
    fill: "#eb742e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.6b7dd237f24389686e6809eff2c5f231.svg";
export { ForwardRef as ReactComponent };